import { Avatar } from '@cbhq/cds-web/media/Avatar';
import '../../ui/Div/index.js';
import { ArrowText } from '../../ui/LinkArrow/ArrowText.js';
import { Text } from '../../ui/Text.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { Div } from '../../ui/Div/Div.js';
function HighlightBlockQuoteAuthor({
  photoUrl,
  name,
  title,
  bio,
  color,
  secondaryColor,
  linkLabel
}) {
  return /*#__PURE__*/jsxs(Div, {
    flexDirection: "column",
    children: [/*#__PURE__*/jsxs(Div, {
      gap: 2,
      children: [/*#__PURE__*/jsx(Avatar, {
        alt: name,
        src: photoUrl,
        size: "xxl"
      }), /*#__PURE__*/jsxs(Div, {
        flexDirection: "column",
        justifyContent: "center",
        children: [/*#__PURE__*/jsx(Text, {
          variant: "label1",
          as: "p",
          color: color || 'foreground',
          children: name
        }), title && /*#__PURE__*/jsx(Text, {
          variant: "label2",
          as: "p",
          color: secondaryColor,
          children: title
        })]
      })]
    }), bio && /*#__PURE__*/jsx(Text, {
      variant: "label2",
      color: secondaryColor,
      spacingTop: 3,
      as: "p",
      children: bio
    }), linkLabel && /*#__PURE__*/jsx(ArrowText, {
      children: linkLabel
    })]
  });
}
export { HighlightBlockQuoteAuthor };
//# sourceMappingURL=HighlightBlockQuoteAuthor.js.map
